import React from "react";
import { TableRow, TableCell, Text } from "@thecb/components";
import { CHARADE_GREY } from "/constants/colors";
import ActivityCell from "./ActivityCell";

const ActivityRow = ({
  activity,
  tableCellPadding,
  customerManagement,
  linkColor,
  fontSize
}) => {
  return (
    <TableRow key={activity.id}>
      <TableCell padding={tableCellPadding} maxWidth="13.75rem">
        <Text color={CHARADE_GREY} fontSize={fontSize}>
          {activity.action}
        </Text>
      </TableCell>
      <TableCell padding={tableCellPadding} maxWidth="11.25rem">
        <Text color={CHARADE_GREY} fontSize={fontSize}>
          {activity.user}
        </Text>
      </TableCell>
      <TableCell padding={tableCellPadding} maxWidth="13.75rem">
        <ActivityCell
          activity={activity}
          customerManagement={customerManagement}
          linkColor={linkColor}
        />
      </TableCell>
      <TableCell
        padding={tableCellPadding}
        extraStyles={"min-width: 10.9rem"}
        maxWidth="11.25rem"
      >
        <Text color={CHARADE_GREY} fontSize={fontSize}>
          {activity.date}
        </Text>
      </TableCell>
    </TableRow>
  );
};

export default ActivityRow;
